import React, { Component } from "react";
import myplexAPI from "../../api/myplexAPI";
// import Img from "../Uicomponents/Img";
import Img from "../../utils/similarContentImg";
import OwlCarousel from "react-owl-carousel2";
import { parseDate } from "../../utils/portalhelper";
import { Link } from "react-router-dom";
// import {slugify} from '../../utils/stringSlugify';
// import {getURLName} from "../../utils/urlMenu";

import {slugify} from '../../../commonfiles/stringSlugify';
import {getURLName} from "../../../commonfiles/urlMenu";

export default class Epg extends Component {
  state = {
    channelEPG: [],
    currentplaying: [],
    pageName: "Home"
  };
  componentDidMount() {
    //console.log(this.props);
    // const existingScript = document.getElementById("Jquery");
    // if (!existingScript) {
    //   const script = document.createElement("script");
    //   script.src = "/assets/jquery-3.4.1.min.js";
    //   script.id = "Jquery";
    //   document.body.appendChild(script);
    //   script.onload = () => {
    //     this._parseData();
    //   };
    // } else {
    this._parseData();
    // }

    const page_name = window.location.pathname.split("/")[1];
    if (page_name !== "") {
      this.setState({
        pageName: page_name
      });
    }
  }
  componentDidUpdate(prevProps) {
    //console.log(sessionStorage.getItem("Logged-in"));
    if (prevProps.ContentId !== this.props.ContentId) {
      this._parseData();
    }
  }
  channelEPG = () =>
    this.state.channelEPG.map((content, i) => {
      const start_date = parseDate(content.startDate);
      const end_date = parseDate(content.endDate);
      return (
        <div key={i} className="live_streaming">
          <Img caroselimg={content} key={i} />
          <h2>{content.title}</h2>
          <span>
            {`${start_date.getHours()}:${(start_date.getMinutes() < 10
              ? "0"
              : "") + start_date.getMinutes()}-
            ${end_date.getHours()}:${(end_date.getMinutes() < 10 ? "0" : "") +
              end_date.getMinutes()}`}
          </span>
        </div>
      );
    });
  epgList = () =>
    this.state.currentplaying.map((content, i) => {
      let id = content.generalInfo._id.split('_');
      try{
        id = id[0];
      }catch (e) {
        id = content.generalInfo._id;
      }

      return (
        //this.props.ContentId !== content.globalServiceId && (
        <Link
          to={{
            pathname: `/${ getURLName( content, this.state.pageName ) }/detail/${id}/${slugify(content.globalServiceName)}`
            // search: `?videotype=${content.generalInfo.type}`
          }}
          key={i}
        >
          <div key={i} className="live_streaming">
            <Img caroselimg={content} key={i} />
            <h2>{content.globalServiceName}</h2>
            <h3>{content.title}</h3>
          </div>{" "}
        </Link>
        // )
      );
    });
  FilterEpg = item => {
    var date = parseDate(item.startDate);
    var Currentdate = parseDate();
    if (Currentdate < date) {
      return true;
    }
  };

  _parseData = () => {
    myplexAPI.getchannelEPG(this.props.ContentId).then(response => {
      if(response.data.status === 'SUCCESS') {
        this.setState({
          channelEPG: response.data.results.filter(this.FilterEpg)
        });
      }
    });
    if(this.props.data.content.genre.length > 0) {
      myplexAPI
          .getEPGList(
              this.props.data.content.genre[0].name,
              this.props.data.content.language[0]
          )
          .then(response => {
            // eslint-disable-next-line
            {
              // console.log(response);
              if (response.data.status === 'SUCCESS') {
                this.setState({
                  currentplaying: response.data.results.filter(
                      item => item.globalServiceId !== this.props.ContentId
                  )
                });
              }
            }
          });
    }
  };
  sourceDetails = source_details => {
    localStorage.setItem("source details", source_details);
    localStorage.setItem("source", "carousel");
    localStorage.setItem('trackingId','');

  };
  render() {
    const options = {
      items: 7,

      responsive: {
        320: {
          items: 2,
          nav: true
        },
        481: {
          items: 3,
          nav: false
        },
        768: {
          items: 4,
          nav: false
        },
        1200: {
          items: 5,
          nav: true
        },
        1300: {
          items: 6,
          nav: true
        },
        1400: {
          items: 8,
          nav: true
        }
      },
      nav: true,
      navText: [
        "<i class='carousel_leftarrow'/>",
        "<i class='carousel_rightarrow'/>"
      ],
      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      loop: false
    };

    const events = {
      onDragged: function(event) {},
      onChanged: function(event) {}
    };

    return (
      <div>
        <section>
          {this.state.channelEPG.length > 0 && (
            <div className="carousel_body">
              <div className="home_carosel_title">
                <h4>{this.props.upcoming_programs}</h4>
              </div>
              <div className="carosel_slider">
                <OwlCarousel ref="car" options={options} events={events}>
                  {this.channelEPG()}
                </OwlCarousel>
              </div>
            </div>
          )}
          {this.state.currentplaying.length > 0 && (
            <div className="carousel_body">
              <div className="home_carosel_title">
                <h4>{this.props.currently_playing_on_other_channels}</h4>
              </div>

              <div
                className="carosel_slider"
                onClick={() =>
                  this.sourceDetails("Currently Playing On Other Channels")
                }
              >
                <OwlCarousel ref="car" options={options} events={events}>
                  {this.epgList()}
                </OwlCarousel>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}
